import { getStorageKey } from '@/utils';

export type IDirection = 'rtl' | 'ltr';

export const getDefaultDirection = (): IDirection => {
  const storageDirection = localStorage.getItem(getStorageKey('direction')) as IDirection;
  return storageDirection || 'ltr';
};
